import Error from "../../components/Error/Error.jsx";

const NotFound = () => {
  document.title = "Dev'Alls - Page introuvable";
  return (
    <>
      <main>
        <Error />
      </main>
    </>
  );
};

export default NotFound;
